import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet } from 'react-router-dom';
import { Loader } from 'components/Base';
import { env } from 'env';

export const RequiredAuth: React.FC = () => {
  const { oktaAuth, authState, _onAuthRequired } = useOktaAuth();

  useEffect(() => {
    if (!authState || !oktaAuth || authState?.isAuthenticated) {
      return;
    }

    const originalUri = `${env.REACT_APP_BASE_URL}/login`;

    oktaAuth.setOriginalUri(originalUri);

    if (_onAuthRequired) {
      _onAuthRequired(oktaAuth);
    } else {
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated, _onAuthRequired]);

  if (!authState || !authState?.isAuthenticated) {
    return <Loader />;
  }

  return <Outlet />;
};

export default RequiredAuth;
